import { render, staticRenderFns } from "./PartnerTestimonials.vue?vue&type=template&id=0d452410&scoped=true&"
import script from "./PartnerTestimonials.vue?vue&type=script&lang=js&"
export * from "./PartnerTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTestimonials.vue?vue&type=style&index=0&id=0d452410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d452410",
  null
  
)

export default component.exports